//
import React from 'react'

import { Spinner } from 'spin.js'

import 'spin.js/spin.css'

class LoadingSpinner extends React.Component {
  constructor (props) {
    super(props)
    //
    this.spinner = null //  riferimento a oggetto javascript Spinner
    this.spinnerRef = React.createRef()
  }

  componentDidMount () {
    //
    const config = {
      lines: 6,
      length: 0,
      width: 10,
      radius: 10,
      corners: 1,
      rotate: 0,
      direction: 1,
      color: '#4CBAD7',
      opacity: 0.1,
      speed: 1.4,
      trail: 100,
      shadow: false,
      hwaccel: true,
      className: 'spinner',
      zIndex: 200,
      top: '50%',
      left: '50%'
    }
    //
    if (this.spinnerRef && this.spinnerRef.current) {
      this.spinner = new Spinner(config).spin(this.spinnerRef.current)
    }
  }

  componentWillUnmount () {
    if (this.spinner && this.spinner.stop) {
      this.spinner.stop()
    }
  }

  render () {
    return (
      <span className='spinner-container' ref={this.spinnerRef}>
        {this.props.children &&
          <span className='loading-text'>{this.props.children}</span>}
      </span>
    )
  }
}

export default LoadingSpinner
